import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { isEmpty } from 'bold-ui'

import { ConsultaSeguimentoPergunta03Model } from './model-consultaSeguimentoPergunta03'
import { hasPergunta03ExemplosAnySim, isPergunta03ExemplosAllNao } from './utils-consultaSeguimentoPergunta03'

export const PERGUNTA_03_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta03Model> = {
  PERGUNTA_03_HEADER: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: 'PERGUNTA_03_EXEMPLOS',
      },
    ],
  },
  PERGUNTA_03_EXEMPLOS: {
    scrollConditions: [
      {
        if: (_, allValues) => hasPergunta03ExemplosAnySim(allValues),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (_, allValues) => isPergunta03ExemplosAllNao(allValues),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_03_HEADER',
  },
}
